<!-- 民乐报 -->
<template>
  <div>民乐报</div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style scoped></style>
